const providersTabs = [
  { label: 'All Providers', href: '/marketplace/providers' },
  {
    label: 'Your Providers',
    href: '/marketplace/providers/your-providers',
  },
  {
    label: 'Saved Providers',
    href: '/marketplace/providers/saved',
  },
];

const requestTabs = [
  { label: 'All Requests', href: '/marketplace/iso' },
  { label: 'Your Requests', href: '/marketplace/iso/your-requests' },
  { label: 'Saved Requests', href: '/marketplace/iso/saved' },
];

const distances = [
  { label: 'All', value: 'all' },
  { label: '10 mi', value: '10' },
  { label: '20 mi', value: '20' },
]

const sortByValues = [
  { label: 'Date (Newest First)', value: 'dateDesc' },
  { label: 'Date (Oldest First)', value: 'dateAsc' },
  { label: 'Price (High to Low)', value: 'priceDesc' },
  { label: 'Price (Low to High)', value: 'priceAsc' },
]

const listingSortButtons = [
  { label: 'Selling', value: 'selling' },
  { label: 'Sold', value: 'sold' },
  { label: 'Expired', value: 'expired' },
]
const providerSortButtons = [
  { label: 'Selling', value: 'selling' },
  { label: 'Hired', value: 'hired' },
]

const isoAndProvidersSortButtons = [
  { label: 'Selling', value: 'selling' },
  { label: 'Hired', value: 'hired' },
]
// Convert our sort value to the format PagesHeader expects
const convertSortForPagesHeader = (sortValue: string): string => {
  switch (sortValue) {
    case 'newest':
      return 'dateDesc';
    case 'oldest':
      return 'dateAsc';
    case 'priceLow':
      return 'priceAsc';
    case 'priceHigh':
      return 'priceDesc';
    default:
      return sortValue;
  }
};

// Convert PagesHeader sort back to our format
const convertSortFromPagesHeader = (sortValue: string): string => {
  switch (sortValue) {
    case 'dateDesc':
      return 'newest';
    case 'dateAsc':
      return 'oldest';
    case 'priceAsc':
      return 'priceLow';
    case 'priceDesc':
      return 'priceHigh';
    default:
      return sortValue;
  }
};

export {
  providersTabs,
  providerSortButtons,
  convertSortFromPagesHeader,
  convertSortForPagesHeader,
  requestTabs,
  distances,
  sortByValues,
  listingSortButtons,
  isoAndProvidersSortButtons
}